import videojs from "video.js";
import tools from "tools";

export default function initPlayerOverlay(player, content) {
  if (player.overlay) {
    player.overlay.children().forEach(e => {
      if (e.name_ === content.name) {
        player.overlay.removeChild(e);
      }
    });

    player.overlay.addChild(new player.OverlayContent(player, content));
    return 0;
  }

  const videoJsComponentClass = videojs.getComponent("Component");

  player.OverlayContent = videojs.extend(videoJsComponentClass, {
    constructor(vjs, options) {
      videoJsComponentClass.call(this, vjs, options);
      this.hide();
    },
  });

  player.OverlayContent.prototype.isVisible = false;

  player.OverlayContent.prototype.show = function() {
    this.el().style.display = "block";
    this.isVisible = true;
  };

  player.OverlayContent.prototype.hide = function() {
    this.el().style.display = "none";
    this.isVisible = false;
  };

  player.Overlay = videojs.extend(videoJsComponentClass, {
    constructor(vjs, overlayContentEl) {
      videoJsComponentClass.call(this, vjs);
      this.hide();
      this.el().className = "vjs-overlay";
      this.el().style.backgroundColor = "rgba(0, 0, 0, 0.8)";
      this.el().style.position = "absolute";
      this.el().style.top = "0";
      this.el().style.bottom = "0";
      this.el().style.right = "0";
      this.el().style.left = "0";
      vjs.addChild(this);
      this.addChild(new vjs.OverlayContent(vjs, overlayContentEl));
    },
  });

  player.Overlay.prototype.isVisible = false;

  player.Overlay.prototype.show = function() {
    this.el().style.display = "block";
    this.isVisible = true;
  };

  player.Overlay.prototype.hide = function() {
    this.el().style.display = "none";
    this.isVisible = false;
  };

  player.Overlay.prototype.toggle = function(contentName) {
    this.children().forEach(e => {
      if (e.name_ === contentName) {
        if (!e.isVisible) {
          e.show();
          this.show();
        } else {
          e.hide();
          this.hide();
        }
      } else {
        e.hide();
      }
    });
  };

  tools.addCSS(
    "buttons",
    `.vjs-infoButton, .vjs-socialButton{
          opacity: 1;
          -webkit-transition: transform .2s, opacity .2s;
          -moz-transition: transform .2s, opacity .2s;
          -o-transition: transform .2s, opacity .2s;
          transition: transform .2s, opacity .2s;
      }
      .vjs-user-inactive .vjs-infoButton, .vjs-user-inactive .vjs-socialButton{
          opacity: 0 !important;
      }`,
  );

  try {
    document.getElementsByClassName("vjs-control-bar")[0].style.zIndex = 20;
  } catch (e) {
    console.log(e);
  }

  player.overlay = new player.Overlay(player, content);
  const exitButton = document.createElement("div");
  exitButton.className = "vjs-exitOverlay";
  exitButton.onclick = function() {
    player.overlay.hide();
  };
  player.overlay.el().appendChild(exitButton);
  return 1;
}



// WEBPACK FOOTER //
// ./src/js/videoJSExtensions/ui/overlay.js